import { type FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

export const WitnessUnavailableInfoScreen: FC<FlowCustomComponentProps> = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          Extra court forms will be required for this witness
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          Because a witness cannot be reached to sign a statement, New York law requires asking the
          court to dispense with their testimony and providing handwriting verification instead.
        </p>
      </div>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip bg-white p-6">
        <p className="text-sm font-semibold mb-3">What happens next</p>
        <ul className="flex flex-col gap-3 text-sm text-secondary tracking-[-0.28px]">
          <li>
            <span className="font-semibold text-primary">Forms included in your packet:</span>{" "}
            We'll add Form P-8 (Petition to Dispense with Testimony) and Form P-9 (Affidavit
            Proving Handwriting) to your form packet.
          </li>
          <li>
            <span className="font-semibold text-primary">No action needed right now:</span> You can
            complete this roadmap first without pausing to collect signatures.
          </li>
          <li>
            <span className="font-semibold text-primary">How you'll use it:</span> When your packet
            is ready, you'll find someone familiar with the handwriting of the decedent or the
            witness to sign Form P-9 before submitting your filing.
          </li>
        </ul>
      </div>
    </div>
  );
};

